import React from 'react';
import { Coffee, Quote } from 'lucide-react';

export default function Testimonials() {
  const testimonials = [
    {
      text: "It's fu**ing awesome, it's so good, it's the pork. Wow this is delicious, it's everything I've ever wanted it to be. That's a perfect cup of coffee.",
      author: "Lindsey",
      role: "Coffee Enthusiast & Pork Connoisseur",
      isSpecial: true
    },
    {
      text: "The finish is clean and a bit sweet. I enjoyed out of my Dartmouth College Thayer School of Engineering mug which brought back memories of leather bound books and smells of rich mahogany. 8/10",
      author: "Paul",
      role: "Coffee Connoisseur"
    },
    {
      text: "I think the tasting notes are spot on; right out of the can the smell is intoxicating. I use it in an espresso machine and it brewed up beautifully. We've been using the same blend from another local roaster for 10+ years and this coffee stands up very well against that.",
      author: "Kevin",
      role: "Long-time Coffee Enthusiast"
    },
    {
      text: "I hate to say it, but the coffee was good. A good logo and I might trade in my Pete's.",
      author: "Katie",
      role: "Reluctant Fan"
    },
    {
      text: "Loved this. Lots of flavor and so smooth. Look forward to the next cup!",
      author: "Nat",
      role: "Coffee Enthusiast"
    }
  ];

  return (
    <section id="testimonials" className="py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        {[...Array(6)].map((_, i) => (
          <Coffee
            key={i}
            className="absolute text-white/20 animate-float"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              width: `${Math.random() * 60 + 40}px`,
              height: `${Math.random() * 60 + 40}px`,
              animationDelay: `${Math.random() * 2}s`,
              animationDuration: `${Math.random() * 4 + 4}s`,
              transform: `rotate(${Math.random() * 360}deg)`,
              opacity: 0.8
            }}
          />
        ))}
        <div className="absolute inset-0 bg-[#132947]/80" />
      </div>

      <div className="container mx-auto px-4 relative">
        <h2 className="text-4xl font-bold text-center mb-16 text-[#fda36b]">
          What People Are Saying
        </h2>
        
        {/* Special Lindsey Quote */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-gradient-to-br from-[#fda36b]/20 to-[#fda36b]/10 backdrop-blur-sm p-8 rounded-2xl border-2 border-[#fda36b]/30 relative overflow-hidden">
            <div className="absolute top-4 right-4 bg-[#fda36b] text-[#132947] px-3 py-1 rounded-full text-sm font-bold">
              Be like Lindsey ☕
            </div>
            <Quote className="w-12 h-12 text-[#fda36b] mb-6" />
            <p className="text-white text-xl leading-relaxed mb-6 italic font-medium">
              "It's fu**ing awesome, it's so good, it's the pork. Wow this is delicious, it's everything I've ever wanted it to be. That's a perfect cup of coffee."
            </p>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-[#fda36b] font-bold text-lg">- Lindsey</p>
                <p className="text-white/80 text-sm">Coffee Enthusiast & Professional Pork Referencer</p>
              </div>
              <div className="text-4xl">☕✨</div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            // Skip the special Lindsey testimonial since we display it separately
            testimonial.isSpecial ? null : (
            <div 
              key={index}
              className="bg-white/5 backdrop-blur-sm p-8 rounded-xl hover:bg-white/10 transition-all duration-300 flex flex-col"
            >
              <Quote className="w-10 h-10 text-[#fda36b] mb-4 self-start" />
              <p className="text-white/90 leading-relaxed mb-6 flex-grow italic">
                "{testimonial.text}"
              </p>
              <div>
                <p className="text-[#fda36b] font-semibold">- {testimonial.author}</p>
                <p className="text-white/60 text-sm">{testimonial.role}</p>
              </div>
            </div>
            )
          )).filter(Boolean)}
        </div>
      </div>
    </section>
  );
}